<template lang="pug">
.ppointment-online
  .header-margin-bottom
  .member-center-header
    .arrow_icon(@click="$router.go(-1)")
      img(src="@/assets/images/arrow_left.svg", alt="alt")
    h1 我的預約
  .info-list
    .history_title 近期預約
    .info-item(v-for="( order , index ) in $root.registerOrders" @click="openOrderDetail(order)")
      .info-title {{ order.startTime }}
      .icon-box
        img(src="@/assets/images/arrow_right.svg")
</template>

<script>
export default {
  name: "appointment-online",
  components: {},
  data () {
    return {};
  },
  mounted () {
  },
  methods: {
    openOrderDetail (_order) {
      console.log('_order.carTypes:', _order.carTypes);
      _order.carTypes = JSON.parse(_order.carTypes)
      this.$root.currentRegister = _order
      this.$root.goPage('/order-content')
    }
  },
};
</script>
<style lang="sass" scoped>
body
  position: relative
.ppointment-online
  background-color: #000
  padding: 0 15px
  height: 100%
  overflow: auto
  .arrow_icon
    position: absolute
    top: 6vmin
    left: 6.1vmin
  h1
    font-size: 19px
    font-weight: 700
    text-align: center
    color: #fff
    padding-top: 6vmin
  .info-list
    margin-top: 12.5vmin
    .history_title
      color: #22F48F
      font-size: 4.5vmin
      font-weight: 700
      margin-bottom: 5vmin
    .info-item
      
      display: flex
      justify-content: space-between
      align-items: center
      padding: 6.5vmin 0
      .info-title
        color: #898A8D
        font-size: 5vmin
        font-weight: 400
        padding-left: 2.5vmin
      .icon-box
        width: 6vmin
        height: 6vmin
      .arrow-box
        width: 3vmin
        height: 6.5vmin
        img
          width: 100%
.header-margin-bottom
  margin-bottom: 75px
.member-center-header
  position: fixed
  left: 0px
  top: 0px
  width: 100%
  background: #000
  z-index: 10
  height: 75px
</style>
